module.exports = __webpack_public_path__ + "static/eplus-35ae4296b91cb9c7b7c6c2b61401c251.png";